import React from 'react';
import PropTypes from 'prop-types';
import CurrencyInputInline from '../currency-input-inline';

const BudgetReadonly = ({ budget, budgetStatus, mode, currency }) => {
  const collab = mode === 'collaboration';
  const budgetStyles = {
    display: 'inline-block',
    width: '60%',
  };

  return (
    <div style={budgetStyles}>
      {collab && <p className="small light">Agreed fee</p>}
      <CurrencyInputInline
        id="budget"
        name="budget"
        currency={currency}
        disabled
        value={budget}
        placeholder={0}
        status={budgetStatus}
      />
    </div>
  );
};

BudgetReadonly.propTypes = {
  budget: PropTypes.number.isRequired,
  budgetStatus: PropTypes.string.isRequired,
  mode: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
};

export default BudgetReadonly;



/** WEBPACK FOOTER **
 ** ./src/components/budget-readonly/index.js
 **/